import { useApi } from '../useApi'
// eslint-disable-next-line import/no-unresolved
import { getCatalogRecommendationProducts } from 'data-api'
import { RECOMMENDATION_PRODUCT_TYPE_CROSSSEL } from '../../constants'
import { useEffect } from 'react'
import { useCurrency } from '../../providers/currency'
import { useTrackingsActions } from '../trackings'

export const useProductRecommendations = ({
	type,
	sku,
	tracking = true,
	options,
	pageContext,
	pageId,
	widgetContext,
} = {}) => {
	const { currency } = useCurrency()
	const { productImpressions } = useTrackingsActions()
	const { data, error, isValidating, mutate, cancel, cancelled } = useApi({
		method: getCatalogRecommendationProducts,
		args: { sku, type },
		paused: type === RECOMMENDATION_PRODUCT_TYPE_CROSSSEL ? false : !sku || !type,
		options,
	})

	useEffect(() => {
		if (data?.length && tracking) {
			productImpressions({ products: data, currency, pageContext, pageId, widgetContext })
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [currency, data, productImpressions, pageContext, pageId, widgetContext])

	return {
		products: data,
		loading: isValidating,
		error,
		mutate,
		cancel,
		cancelled,
	}
}
